<template>
  <div>
    <div>
      <ul class="lightrope" v-if="isHoliday()">
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
        <li></li>
      </ul>
    </div>

    <div id="wrapper">
      <notifications></notifications>
      <div id="sidebar-wrapper">
        <ul class="sidebar-nav mt--4">
          <a class="menu-icon" href="/#/admin">
            <img :src="logo" />
          </a>
          <li v-for="item in items" :class="getClass(item)">
            <a href="#" @click.prevent="navClicked(item)"
              ><i :class="item.class"></i>{{ item.label }}</a
            >
          </li>
        </ul>
        <div class="text-center" style="color:gray">
          <small>Build #{{ version }}</small>
        </div>
      </div>
      <div id="page-content-wrapper">
        <div class="page-content mt-4">
          <div class="container-fluid">
            <router-view></router-view>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {},
  inject: ["systemContextService"],
  data() {
    return {
      logo: null,
      version: null,
      items: [
        {
          isActive: false,
          label: "Companies",
          class: "fa-light fa-building",
          href: "/#/admin/companies",
        },
        {
          isActive: false,
          label: "Administrators",
          class: "fa-light fa-id-badge",
          href: "/#/admin/adminusers",
        },

        {
          isActive: false,
          label: "Sysadmin",
          class: "fal fa-wrench",
          href: "/#/admin/sysAdmin",
        },

        {
          isActive: false,
          label: this.$localStorageService.getItem("companyName"),
          class: "fal fa-left-to-line",
          href: "/#/dashboard",
        },
        {
          isActive: false,
          label: "Logout",
          class: "fal fa-right-to-line",
          href: "/#/",
        },
      ],
    };
  },
  watch: {
    $route(to, from) {
      this.items.forEach((e) => {
        e.isActive = false;
      });

      if (to.path == "/dashboard") this.items[0].isActive = true;
      if (to.path == "/transactions") this.items[1].isActive = true;
      if (to.path == "/notifications") this.items[2].isActive = true;
      if (to.path == "/paymentplans") this.items[3].isActive = true;
      if (to.path == "/customermembershipbillings")
        this.items[4].isActive = true;
    },
  },
  methods: {
    isHoliday() {
      let today = new Date();
      let christmasYear = today.getFullYear();

      if (today.getMonth() == 11 && today.getDate() > 25) {
        christmasYear = christmasYear + 1;
      }

      let christmasDate = new Date(christmasYear, 11, 25);
      let dayMilliseconds = 1000 * 60 * 60 * 24;

      let remainingDays = Math.ceil(
        (christmasDate.getTime() - today.getTime()) / dayMilliseconds
      );

      if (remainingDays >= 0 && remainingDays <= 31) return true;
      else return false;
    },
    getClass(item) {
      let c = "";

      if (item.isActive === true) c = "active";

      return c;
    },
    navClicked(item) {
      location.href = item.href;
    },
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  mounted() {
    this.initScrollbar();
    this.version = this.$localStorageService.getItem("version");
    this.logo = this.systemContextService.getSystem().dashboardImageUrl;
  },
};
</script>

<style scoped>
#wrapper {
  padding-left: 150px;
}

.menu-icon {
  padding: 30px 0 50px 0;
  display: block;
  text-align: center;
}

.menu-icon img {
  width: 55px;
}

#sidebar-wrapper {
  margin-left: -150px;
  left: 155px;
  width: 150px;

  position: fixed;
  height: 100%;
  overflow-y: auto;
  z-index: 1000;
}

#page-content-wrapper {
  width: 100%;
}

.lightrope {
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  position: fixed;
  z-index: 1;
  margin: -40px 0 0 0;
  padding: 0;
  pointer-events: none;
  width: 100%;
}
.lightrope li {
  position: relative;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
  list-style: none;
  margin: 0;
  padding: 0;
  display: block;
  width: 12px;
  height: 28px;
  border-radius: 50%;
  margin: 20px;
  display: inline-block;
  background: #00f7a5;
  box-shadow: 0px 4.6666666667px 24px 3px #00f7a5;
  -webkit-animation-name: flash-1;
  animation-name: flash-1;
  -webkit-animation-duration: 2s;
  animation-duration: 2s;
}
.lightrope li:nth-child(2n + 1) {
  background: blue;
  box-shadow: 0px 4.6666666667px 24px 3px blue;
  -webkit-animation-name: flash-2;
  animation-name: flash-2;
  -webkit-animation-duration: 0.4s;
  animation-duration: 0.4s;
}
.lightrope li:nth-child(4n + 2) {
  background: red;
  box-shadow: 0px 4.6666666667px 24px 3px red;
  -webkit-animation-name: flash-3;
  animation-name: flash-3;
  -webkit-animation-duration: 1.1s;
  animation-duration: 1.1s;
}
.lightrope li:nth-child(odd) {
  -webkit-animation-duration: 1.8s;
  animation-duration: 1.8s;
}
.lightrope li:nth-child(3n + 1) {
  -webkit-animation-duration: 1.4s;
  animation-duration: 1.4s;
}
.lightrope li:before {
  content: "";
  position: absolute;
  background: #222;
  width: 10px;
  height: 9.3333333333px;
  border-radius: 3px;
  top: -4.6666666667px;
  left: 1px;
}
.lightrope li:after {
  content: "";
  top: -14px;
  left: 9px;
  position: absolute;
  width: 52px;
  height: 18.6666666667px;
  border-bottom: solid #222 2px;
  border-radius: 50%;
}
.lightrope li:last-child:after {
  content: none;
}
.lightrope li:first-child {
  margin-left: -40px;
}

@-webkit-keyframes flash-1 {
  0%,
  100% {
    background: green;
    box-shadow: 0px 4.6666666667px 24px 3px green;
  }
  50% {
    background: darkgreen;
    box-shadow: 0px 4.6666666667px 24px 3px darkgreen;
  }
}

@keyframes flash-1 {
  0%,
  100% {
    background: green;
    box-shadow: 0px 4.6666666667px 24px 3px green;
  }
  50% {
    background: darkgreen;
    box-shadow: 0px 4.6666666667px 24px 3px darkgreen;
  }
}
@-webkit-keyframes flash-2 {
  0%,
  100% {
    background: blue;
    box-shadow: 0px 4.6666666667px 24px 3px blue;
  }
  50% {
    background: lightblue;
    box-shadow: 0px 4.6666666667px 24px 3px lightblue;
  }
}
@keyframes flash-2 {
  0%,
  100% {
    background: blue;
    box-shadow: 0px 4.6666666667px 24px 3px blue;
  }
  50% {
    background: darkblue;
    box-shadow: 0px 4.6666666667px 24px 3px darkblue;
  }
}
@-webkit-keyframes flash-3 {
  0%,
  100% {
    background: red;
    box-shadow: 0px 4.6666666667px 24px 3px red;
  }
  50% {
    background: darkred;
    box-shadow: 0px 4.6666666667px 24px 3px darkred;
  }
}
@keyframes flash-3 {
  0%,
  100% {
    background: red;
    box-shadow: 0px 4.6666666667px 24px 3px red;
  }
  50% {
    background: darkred;
    box-shadow: 0px 4.6666666667px 24px 3px darkred;
  }
}
</style>
